module.exports = __webpack_public_path__ + "../QA/appsettings.js";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=../QA/[name].[ext]!./configs/appSettings/QA/appsettings.js
// module id = 761
// module chunks = 1